import { render, staticRenderFns } from "./ChoiceEiwa.vue?vue&type=template&id=5c9a83e3&scoped=true"
import script from "./ChoiceEiwa.vue?vue&type=script&lang=js"
export * from "./ChoiceEiwa.vue?vue&type=script&lang=js"
import style0 from "./ChoiceEiwa.vue?vue&type=style&index=0&id=5c9a83e3&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c9a83e3",
  null
  
)

export default component.exports